import { render, staticRenderFns } from "./BuilderEmailComposer.vue?vue&type=template&id=6426b811"
import script from "./BuilderEmailComposer.vue?vue&type=script&lang=js"
export * from "./BuilderEmailComposer.vue?vue&type=script&lang=js"
import style0 from "./BuilderEmailComposer.vue?vue&type=style&index=0&id=6426b811&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports